module.exports = __webpack_public_path__ + "assets/img/vticon.8f7e72e4.svg";